// src/components/Loader.jsx
import React from "react";

const Loader = () => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background-color text-navy animate-fadelong text-xl font-display text-bold">
      <img
        src={"/various/50yrslogo.webp"}
        className="w-1/6 object-contain"
        alt="50 years logo"
      />
    </div>
  );
};

export default Loader;